import { Box, Step, StepLabel, Stepper, Typography } from "@mui/material";
import { PAGES } from "./CreateBookingWrapper";
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";
import { UPLOAD_DOCS_DISCLAIMER } from "../../features/Constants";

export interface StepperProps {
  page: PAGES;
}

const StepperWrapper = (props: StepperProps) => {
  const [readMore, setReadMore] = useState(false);
  const [displayDisclaimer, setDisplayDisclaimer] = useState(true);

  const getStepFromPage = (page: PAGES) => {
    switch (page) {
      case PAGES.CreateBooking:
        return 0;
      case PAGES.UploadSupportingDocs:
        return 1;
      case PAGES.Confirmation:
        return 2;
      default: {
        return 0;
      }
    }
  };

  const truncateDisclaimer = (): string => {
    return readMore ? UPLOAD_DOCS_DISCLAIMER : `${UPLOAD_DOCS_DISCLAIMER.slice(0, 200)}...`;
  }

  const hideDisclaimer = () => {
    setDisplayDisclaimer(false);
  }

  const toggleReadMore = () => {
    setReadMore(!readMore);
  }

  return (
    <>
      {props.page === PAGES.UploadSupportingDocs && displayDisclaimer
        ? <Box sx={{ p: "12px", borderRadius: "8px", backgroundColor: "#fffae8", mt: "8px", mb: "22px" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: "8px" }}>
              <Typography sx={{ color: "#b25102" }}><strong>Disclaimer</strong></Typography>
              <CloseIcon onClick={hideDisclaimer} sx={{ color: "#b25102" }}></CloseIcon>
            </Box>
            <Typography sx={{ color: "#b25102", fontSize: "14px" }}>{truncateDisclaimer()}</Typography>
            <Typography onClick={toggleReadMore} sx={{ textDecoration: "underline", color: "#b25102", pt: "8px", fontSize: "14px" }}><strong>{readMore ? "Read Less" : "Read More"}</strong></Typography>
          </Box>
        : null
      }

      <Box sx={{ display: { xs: "block", md: "block" } }} role="slider" aria-valuenow={getStepFromPage(props.page)} aria-label="Stepper">
        <Stepper activeStep={getStepFromPage(props.page)}>
          <Step
            key={PAGES.CreateBooking}
            completed={props.page > PAGES.CreateBooking}
          >
            <StepLabel aria-label="Booking Details">Booking Details</StepLabel>
          </Step>
          <Step
            key={PAGES.UploadSupportingDocs}
            completed={props.page > PAGES.UploadSupportingDocs}
          >
            <StepLabel aria-label="Upload Supporting Documents">Upload Supporting Documents</StepLabel>
          </Step>
          <Step
            key={PAGES.Confirmation}
            completed={props.page === PAGES.Confirmation}
          >
            <StepLabel aria-label="Confirmation">Confirmation</StepLabel>
          </Step>
        </Stepper>
      </Box>
    </>
  );
};

export default StepperWrapper;
